module.exports = __webpack_public_path__ + "media/images/check_round-c7e3abb416a2b91cbe55cc0385908425.svg";